import Config from '../../config';
import { FeedActions, getFeedActions } from './FeedState';
import { LoginCountActions } from '../global/actions/LoginCountActions';
import { NotificationActions } from '../global/actions';

// LoginCountWebSocketService.ts
class LoginCountWebSocketService {
  private static instance: LoginCountWebSocketService;
  private ws: WebSocket | null = null;

  private constructor() {}

  // Singleton instance access
  public static getInstance(): LoginCountWebSocketService {
    if (!LoginCountWebSocketService.instance) {
      LoginCountWebSocketService.instance = new LoginCountWebSocketService();
      console.log('new login count websocket instance created');
    }
    return LoginCountWebSocketService.instance;
  }

  // Initialize WebSocket connection
  public async connect(dispatch: React.Dispatch<FeedActions>, dispatcher: any, globalDispatch: any, apiToken: string) {
    try {
      if (!this.ws || this.ws.readyState === WebSocket.CLOSED) {
        this.ws = new WebSocket(Config.loginCountWebsockets + '?token=' + apiToken);

        this.ws.onopen = () => {
          dispatcher.connected();
          getFeedActions(dispatch).setLoginCountFeedStatus('open');
          globalDispatch(
            NotificationActions.hide({
              status: 'Error',
              title: 'Login Count WebSocket Error',
              message: '',
              global: false,
              time: new Date(),
              key: 'login-count-feed-error',
              read: false,
              hide: false,
              viewed: false,
            })
          );
          globalDispatch(
            NotificationActions.read({
              status: 'Error',
              title: 'Login Count WebSocket Error',
              message: '',
              global: false,
              time: new Date(),
              key: 'login-count-feed-error',
              read: false,
              hide: false,
              viewed: false,
            })
          );
        };

        this.ws.onmessage = (ev: MessageEvent) => {
          const jsonVal = ev.data;
          const loginCountVal: { count: number; updateTime: Date } = JSON.parse(jsonVal);
          globalDispatch(LoginCountActions.receivedLoginCount({ loginCount: loginCountVal.count }));
        };

        this.ws.onclose = (ev: CloseEvent) => {
          if (ev.reason) {
            getFeedActions(dispatch).setLoginCountCloseReason(ev.reason);
            console.warn(ev.reason);
          }
          getFeedActions(dispatch).setLoginCountFeedStatus('closed');
          globalDispatch(
            NotificationActions.add({
              status: 'Error',
              title: 'Login Count WebSocket Error',
              message: ev.reason ? ev.reason : 'Login Count Websocket error',
              global: false,
              time: new Date(),
              key: 'login-count-feed-error',
              read: false,
              hide: false,
              viewed: false,
            })
          );
        };

        this.ws.onerror = error => {
          dispatcher.errored({ error: error, reason: 'Unable to connect', message: 'Datafeed error' });
          getFeedActions(dispatch).setLoginCountFeedStatus('error');
          console.error('Login Count WebSocket error:', error);
          globalDispatch(
            NotificationActions.add({
              status: 'Error',
              title: 'Login Count WebSocket Error',
              message: 'Login Count Websocket error',
              global: false,
              time: new Date(),
              key: 'login-count-feed-error',
              read: false,
              hide: false,
              viewed: false,
            })
          );
        };
      }
    } catch (createWebsocketError) {
      dispatcher.errored({
        error: createWebsocketError,
        reason: 'Error creating login count websocket',
        message: 'Login Count Websocket error',
      });
    }
  }
  // Send message to WebSocket
  public sendMessage(data: string | ArrayBufferLike | Blob | ArrayBufferView) {
    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      this.ws.send(data);
    } else if (this.ws) {
      console.warn('trying to send message to closed/closing websocket', data);
    }
  }

  public shouldTryReconnect = () => {
    if (!this.ws || this.ws.readyState === WebSocket.CLOSED) {
      return true;
    }
    return false;
  };

  // Close WebSocket connection
  public closeConnection() {
    if (this.ws) {
      this.ws.close();
    }
  }
}

export const loginCountWebSocketService = LoginCountWebSocketService.getInstance();
